import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useMemo } from "react";

const classNames = {
  root: `FooterRoot`
};

export function useFooterStyles() {
  const { semanticColors } = useTheme();

  const styles = useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          color: semanticColors.disabledBodySubtext
        }
      ]
    }),
    [semanticColors]
  );

  const iconStyles = useMemo(
    () => mergeStyleSets({
      icon: {
        padding: `0 0`
      }
    }),
    []
  );

  return { styles, iconStyles };
}
